module.exports = __webpack_public_path__ + "app-static/img/icon_ys.726af312.png";